var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotel_container"
  }, [(!_vm.detailFlag) ? _c('div', {
    staticClass: "hotel_list_box container"
  }, [_c('b-container', [(_vm.hotelLists.length > 0) ? _c('b-row', _vm._l((_vm.hotelLists), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "md": "6",
        "lg": "4"
      },
      on: {
        "click": function($event) {
          return _vm.checkDetail(i)
        }
      }
    }, [(i < 9) ? _c('div', {
      staticClass: "hotel_list_box_item mt-40"
    }, [_c('div', {
      staticClass: "img_mask"
    }, [_c('div', [_c('i', {
      staticClass: "el-icon-search"
    })]), _vm._v(" "), _c('img', {
      staticClass: "item_img",
      attrs: {
        "src": v.coverImg,
        "height": "230px",
        "alt": v.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-20 color-fff fs-20"
    }, [_vm._v(_vm._s(v.title))])]) : _vm._e()])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container text-center color-ccc fs-30 empty-tip "
  }, [_vm._v(_vm._s(_vm.$t('public.nomore')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailFlag) ? _c('div', {
    staticClass: "detail_wrap container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.hotelList[_vm.curIndex].desc)
    }
  })]) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89b80dc4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/hotel.vue
// module id = null
// module chunks = 